import React from "react";

const StyledH2Heading = ({ children, font }) => {
  return (
    <h2 className={`text-h2 font-star-jedi lowercase leading-[120%] ${font}`}>
      {children}
    </h2>
  );
};

export default StyledH2Heading;
